import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthRealmService {
  static isWackerNeusonDomain(hostname = window.location.hostname): boolean {
    return hostname === environment.APP_WACKER_NEUSON_DOMAIN;
  }

  static isTriathlonDomain(hostname = window.location.hostname): boolean {
    return hostname === environment.APP_TRIATHLON_DOMAIN;
  }

  static getAuthBaseUrl(hostname = window.location.hostname): string {
    if (AuthRealmService.isWackerNeusonDomain(hostname)) {
      return environment.APP_WACKER_NEUSON_KEYCLOAK_BASE_URL;
    }
    if (AuthRealmService.isTriathlonDomain(hostname)) {
      return environment.APP_TRIATHLON_KEYCLOAK_BASE_URL;
    }
    return environment.APP_KEYCLOAK_BASE_URL;
  }

  static getRealm(hostname = window.location.hostname): string {
    if (AuthRealmService.isWackerNeusonDomain(hostname)) {
      return environment.APP_WACKER_NEUSON_REALM;
    }
    if (AuthRealmService.isTriathlonDomain(hostname)) {
      return environment.APP_TRIATHLON_REALM;
    }
    return environment.APP_REALM;
  }

  public static prepareUrl(url: string, hostname = window.location.hostname): string {
    if (AuthRealmService.isWackerNeusonDomain(hostname)) {
      return AuthRealmService.replaceUrl(url, environment.APP_DOMAIN, environment.APP_WACKER_NEUSON_DOMAIN);
    }
    if (AuthRealmService.isTriathlonDomain(hostname)) {
      return AuthRealmService.replaceUrl(url, environment.APP_DOMAIN, environment.APP_TRIATHLON_DOMAIN);
    }

    return url;
  }

  private static replaceUrl(url: string, base: string, replacement: string): string {
    if (url.includes(base)) {
      return url.replace(base, replacement);
    }

    if (base.startsWith('app.')) {
      base = base.replace('app.', '');
      replacement = replacement.replace('app.', '');
      return url.replace(base, replacement);
    }

    return url;
  }
}
